<template>
	<div class="pulbic_oparetionBlock">
		<!-- 查询 -->
		<div class="public_criteriaRange">
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">车牌号：</label>
				<div class="el-select public_optionSty">
					<el-input v-model="carNum" placeholder="请输入车牌号"></el-input>
				</div>
			</div>
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">车牌颜色：</label>
				<el-select class="public_optionSty dropDown_Define" v-model="carColor">
					<el-option v-for="item in colorList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">开始时间：</label>
				<div class="el-select public_optionSty">
					<el-date-picker style="width: 10vw;" v-model="startTime" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</div>
			</div>
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">结束时间：</label>
				<div class="el-select public_optionSty">
					<el-date-picker style="width: 10vw;" v-model="endTime" type="datetime" placeholder="选择日期">
					</el-date-picker>
				</div>
			</div>
			<!-- <div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">起点:</label>
				<div class="el-select public_optionSty">
					<el-input v-model="startLocal" placeholder="请输入起点"></el-input>
				</div>
			</div>
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">终点:</label>
				<div class="el-select public_optionSty">
					<el-input v-model="endLocal" placeholder="请输入终点"></el-input>
				</div>
			</div> -->
			<div style="margin-left: 20px;">
				<el-button style="font-size: 0.7vw;" type="primary" size="small" @click="handleQuery()">查询</el-button>
				<el-button style="font-size: 0.7vw;" type="primary" size="small" @click="handleDetail">时间线详情</el-button>
			</div>
		</div>
		<!-- 时间轴弹窗 -->
		<div class="tiem-dialog">
			<el-dialog :visible.sync="isShow" title="停车时间线" width="40%" append-to-body custom-class="sales-sale-query-of-vehicle-trajectory-dialog">
				<el-timeline v-if="lineArr.length" :reverse="reverse">
					<el-timeline-item v-for="(line, index) in lineArr" :key="line.parkBte"
						:timestamp="`停车时间：${line.startTime}---结束时间：${line.endTime}`">
						{{ line.parkAdr }}
					</el-timeline-item>
				</el-timeline>
				<div v-else>暂无数据</div>
			</el-dialog>
		</div>
		<!-- 地图 -->
		<div ref="mapContainer" v-loading="loading" id="sale-query-vehicle-trajectory-map">
		</div>
	</div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { isWithin72Hours, formatDate, formatTimestamps } from '../../utils/formatDate';
import { batchWgs84ToGcj02, convertWgs84ToGcj02 } from '../../utils/wgs84ToGcj02';
export default {
	name: 'AMapTrack',
	data() {
		return {
			carNum: '',
			startTime: '',
			endTime: '',
			startLocal: '',
			endLocal: '',
			isShow: false,
			reverse: true,
			loading: false,
			map: null,       // 地图实例
			AMap: null,
			marker: null,
			trackData: [],
			lineArr: [],
			carMarker: null,    // 车辆标记
			polyline: null,     // 轨迹线
			passedPolyline: null,
			startMarker: null,  // 起点气球标记
			endMarker: null,    // 终点气球标记
			animationTimer: null,
			trackLine: null,
			markers: [],
			infoWindows: [],
			stopMarkers: [],
			trackArray: [],
			carColor: '',
			colorList: [{ label: '黄色', value: '' }, { label: '绿色', value: '电' }],
		}
	},
	mounted() {
		this.setAMapSecurityConfig()
		this.$nextTick(() => {
			this.initMap()
		})
	},
	beforeDestroy() {
		if (this.map) {
			this.map.destroy();
			this.map = null;
		}
	},
	methods: {
		// 查询
		async handleQuery() {
			this.trackArray = [];
			this.trackData = [];
			this.lineArr = [];
			const is72Hours = isWithin72Hours(this.startTime, this.endTime)
			console.log(is72Hours);
			if (!is72Hours) {
				this.$message({
					message: '时间选择范围小于等于72小时',
					type: 'warning'
				});
			} else {
				const tiemArr = formatDate(this.startTime, this.endTime)
				console.log(tiemArr);
				const url = 'orm/ormtb470/getTrack';
				const data = {
					startTime: tiemArr[0],
					endTime: tiemArr[1],
					number: `${this.carNum}${this.carColor}`
				}
				try {
					this.loading = true;
					const res = await this.axios.post(url, data)
					if (res.status === 200) {
						console.log(res)
						if (res.data.code === 200) {
							this.$message({
								message: res.data.message,
								type: 'success'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
						const { parkArray, trackArray } = res.data.data
						this.trackArray = trackArray
						const newTrackArray = trackArray.map(item => [item.longitude, item.latitude])
						if (newTrackArray.length) {
							const gcj02 = batchWgs84ToGcj02(newTrackArray)
							this.trackData = gcj02
						}
						const newParkArray = parkArray.map(item => {
							const gcj02 = convertWgs84ToGcj02(item.longitude, item.latitude)
							const time = formatTimestamps(item.parkBte, item.parkEte)
							return {
								...item,
								longitude: gcj02[0],
								latitude: gcj02[1],
								...time
							}
						})
						this.lineArr = newParkArray
					}
				} catch (error) {
					console.log('请求出错' + error);
					// this.$message({
					// 	message: '请求出错,请稍后重试',
					// 	type: 'warning'
					// });
				} finally {
					this.loading = false
				}
			}

			//this.startAnimation()
			this.initMap()
		},
		// 时间线详情
		handleDetail() {
			this.isShow = true
		},
			// 初始化地图
			setAMapSecurityConfig() {
				window._AMapSecurityConfig = {
					securityJsCode: '10e9d5e2a4cb4090da1e956220221342',
				}
			},
			async getAMap() {
				this.setAMapSecurityConfig()
				if (this.AMap) return this.AMap
				if (window.AMap && window.AMap.Map) {
					this.AMap = window.AMap
					return this.AMap
				}
				const AMap = await AMapLoader.load({
					key: 'ddc3f919a2106d25341cb70eba4b5c1e',
					version: '2.0',
					plugins: ['AMap.InfoWindow'],
				})
				this.AMap = AMap
				return AMap
			},
			async initMap() {
				try {
					if (!this.$refs.mapContainer) return
					if (this.map) {
						this.map.destroy();
						this.map = null;
					}
					this.markers = []
					this.stopMarkers = []
					this.infoWindows = []
					this.trackLine = null
					const AMap = await this.getAMap()
					if (!this.$refs.mapContainer) return
					this.map = new AMap.Map(this.$refs.mapContainer, {
						resizeEnable: true,
						viewMode: '2D',
						center: this.trackData.length ? [this.trackData[0][0], this.trackData[0][1]] : [116.397428, 39.90923],
						zoom: 13
					});

					if (this.trackData.length) {
						const startMarker = new AMap.Marker({
							map: this.map,
							position: [this.trackData[0][0], this.trackData[0][1]],
							icon: new AMap.Icon({
								image: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
								imageOffset: new AMap.Pixel(0, 0),
							})
						})
						const endMarker = new AMap.Marker({
							map: this.map,
							position: [this.trackData[this.trackData.length - 1][0], this.trackData[this.trackData.length - 1][1]],
							icon: new AMap.Icon({
								image: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
								imageOffset: new AMap.Pixel(0, 0),
							})
						})
						this.markers.push(startMarker, endMarker)
						this.drawTrackLine(this.trackData);
					}

					if (this.lineArr.length) {
						this.markStopPoints();
					}

					const fitOverlays = this.markers.concat(this.stopMarkers)
					if (this.trackLine) fitOverlays.push(this.trackLine)
					if (fitOverlays.length) {
						this.map.setFitView(fitOverlays);
					}
				} catch (error) {
					console.error('高德地图加载失败:', error);
					this.$message({
						message: '地图加载失败，请刷新页面重试',
						type: 'warning'
					});
				}
			},

			// 绘制行驶轨迹线
			drawTrackLine(trackData) {
				const path = trackData.map(point => {
					return point
				});
				this.drawCorrectedTrack(path)
			},
			// 绘制轨迹（蓝色实线）
			drawCorrectedTrack(path) {
				if (!this.map || !this.AMap || !path.length) return
				this.trackLine = new this.AMap.Polyline({
					path: path,
					strokeWeight: 10,
					showDir: true,
					strokeStyle: 'solid',
					lineJoin: 'round'
				});
				this.map.add(this.trackLine);
			},
			// 标记停车点
			markStopPoints() {
				if (!this.map || !this.AMap) return
				this.lineArr.forEach((point, index) => {
					const marker = new this.AMap.Marker({
						position: [point.longitude, point.latitude],
						map: this.map,
						content: this.createStopMarkerIcon(),
						offset: new this.AMap.Pixel(-12, -12)
					});

					const infoContent = `
	            <div style=" color: #fff;" class="info-window">
	              <h4>停车点 ${index + 1}</h4>
								<p><strong>停车地点：</strong>${point.parkAdr}</p>
	              <p><strong>停车时长：</strong>${point.parkMins}分钟</p>
	              <p><strong>坐标：</strong>${point.longitude}, ${point.latitude}</p>
	            </div>
	          `;
					const infoWindow = new this.AMap.InfoWindow({
						content: infoContent,
						offset: new this.AMap.Pixel(0, -30),
					});

					marker.on('mouseover', () => {
						infoWindow.open(this.map, marker.getPosition());
					});

					marker.on('mouseout', () => {
						infoWindow.close();
					});

					this.stopMarkers.push(marker);
					this.infoWindows.push(infoWindow);
				});
			},
		// 创建停车点自定义图标
		createStopMarkerIcon() {
			const div = document.createElement('div');
			div.className = 'stop-marker';
			div.innerHTML = `
        <div class="outer-circle"></div>
        <div class="inner-circle"></div>
				<img src='http://webapi.amap.com/images/marker_sprite.png' />
      `;
			return div;
		},
		/**
 * 批量转换WGS84坐标到GCJ02
 * @param {Array} points - 坐标数组 [[lng,lat],...] 或 [{lng,lat},...]
 * @returns {Promise} 返回转换后的坐标数组
 */
		async batchConvertWGS84ToGCJ02(points) {
			// 高德API每次最多转换40个点
			const BATCH_SIZE = 40;
			const results = [];
			for (let i = 0; i < points.length; i += BATCH_SIZE) {
				const batch = points.slice(i, i + BATCH_SIZE);
				const result = await new Promise(resolve => {
					this.AMap.convertFrom(batch, 'gps', (status, result) => {
						resolve(status === 'complete' ? result.locations : []);
					});
				});
				results.push(...result);
			}

			return results;
		}
	}
}
</script>
<style scoped>
#sale-query-vehicle-trajectory-map {
	box-sizing: border-box;
	width: 100%;
	height: 76vh;
}


.stop-marker {
	position: relative;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.stop-marker .outer-circle {
	position: absolute;
	width: 24px;
	height: 24px;
	background: rgba(255, 0, 0, 0.2);
	border-radius: 50%;
	animation: pulse 1.5s infinite;
}

.stop-marker .inner-circle {
	position: absolute;
	width: 16px;
	height: 16px;
	background: #FF0000;
	border-radius: 50%;
}

.stop-marker .stop-text {
	position: relative;
	color: white;
	font-size: 12px;
	font-weight: bold;
}

@keyframes pulse {
	0% {
		transform: scale(1);
		opacity: 0.7;
	}

	70% {
		transform: scale(1.3);
		opacity: 0.3;
	}

	100% {
		transform: scale(1);
		opacity: 0.7;
	}
}

/* 信息窗体样式 */
.info-window {
	padding: 10px;
}

.info-window h4 {
	margin: 0 0 8px 0;
	color: #333;
	font-size: 16px;
}

.info-window p {
	margin: 6px 0;
	font-size: 13px;
	color: #666;
}

.info-window strong {
	color: #FFF;
}

::v-deep .el-timeline-item__content {
	color: #303133 !important;
}

/deep/.el-timeline-item__timestamp {
	color: #909399 !important;
}
</style>
<style>
.sales-sale-query-of-vehicle-trajectory-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-sale-query-of-vehicle-trajectory-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-sale-query-of-vehicle-trajectory-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-sale-query-of-vehicle-trajectory-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-sale-query-of-vehicle-trajectory-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
